import DelBox from '../comps/DelBox';
import AddGstDetails from '../models/AddGstDetails';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import AddGstDetails1 from '../models/AddGstDetails1';

const GstDetails1 = () => {
    const [formData, setFormData] = useState({
        l1: [],
        cat_type: 'sale_gst',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('cat_type', formData.cat_type + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const delItem = async (editItem) => {
        const fd = new FormData();
        fd.append('cat_id', editItem.cat_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delCatUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {
                initData();
            }
        } catch (error) {

        }
    };

    const handleAddDepart = () => {
        formData.page_no = 0;
        initData();
    };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }

        return () => {
            console.log('Component unmounted');
        };
    }, []);


    return (
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-lg-12">
                        <div class="card" id="orderList">
                            <div class="card-header border-0">
                                <div class="row align-items-center gy-3">
                                    <div class="col-sm">
                                        <h5 class="card-title mb-0">Purchase GST</h5>
                                    </div>
                                    <div class="col-sm-auto">
                                        <div class="d-flex gap-1 flex-wrap">
                                            <button id="addbt453" style={{ display: "none" }} type="button" class="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal" fdprocessedid="jys8hw">
                                            </button>
                                            <button type="button" class="btn btn-success add-btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setEditItem(null);
                                                    document.getElementById("addbt453").click();
                                                }}
                                            >
                                                <i class="ri-add-line align-bottom me-1"></i> Add GST</button>
                                            <button class="btn btn-soft-danger" id="remove-actions">
                                                <i class="ri-delete-bin-2-line"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div class="row g-3">
                                        <div class="col-xxl-5 col-sm-6">
                                            <div class="search-box">
                                                <input class="form-control search" name="search_key" onChange={handleChange} value={formData.search_key} placeholder="Search by name, email, contact..." type="text" fdprocessedid="ws635j" />
                                                <i class="ri-search-line search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <br />
                            <div class="card-body pt-0">
                                <div>

                                    <div class="table-responsive table-card mb-1">
                                        <table class="table table-nowrap align-middle" id="orderTable">
                                            <thead class="text-muted table-light" >
                                                <tr class="text-uppercase">
                                                    <th scope="col">
                                                        <div class="form-check">
                                                            <input class="form-check-input" id="checkAll" type="checkbox" value="option" />
                                                        </div>
                                                    </th>
                                                    <th data-sort="customer_name">Sr. No.</th>
                                                    <th data-sort="customer_name">Item</th>
                                                    <th data-sort="customer_name">Supplier</th>
                                                    <th data-sort="customer_name">Date</th>
                                                    <th data-sort="customer_name">Gst Amount</th>
                                                    <th data-sort="city">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody class="list form-check-all">
                                                {formData.l1.map((item, index) => (
                                                    <tr>
                                                        <th scope="row">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox" value="option1" name="checkAll" />
                                                            </div>
                                                        </th>
                                                        <td class="customer_name">{index + 1}</td>
                                                        <td class="product_name">{item.cat_name}</td>
                                                        <td class="product_name">{item.cat_type1}</td>
                                                        <td class="product_name">{item.cat_type2}</td>
                                                        <td class="product_name">{item.cat_status}</td>
                                                        <td>
                                                            <ul class="list-inline hstack gap-2 mb-0">
                                                                <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Edit" data-bs-original-title="Edit">
                                                                    <a href="javascript:void(0)" onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setEditItem(item);
                                                                        document.getElementById("addbt453").click();
                                                                    }} class="text-primary d-inline-block edit-item-btn">
                                                                        <i class="ri-pencil-fill fs-16"></i>
                                                                    </a>
                                                                </li>
                                                                <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                                                    <a class="text-danger d-inline-block remove-item-btn" onClick={(e) => {
                                                                        e.preventDefault();
                                                                        delItem(item);
                                                                    }}>
                                                                        <i class="ri-delete-bin-5-fill fs-16"></i>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                        {/* <div class="noresult">
                        <div class="text-center">
                          <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                          <h5 class="mt-2">Sorry! No Result Found</h5>
                          <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                        </div>
                      </div> */}
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <div class="pagination-wrap hstack gap-2">
                                            <a class="page-item pagination-prev disabled" href="javascript:void(0)"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (formData.page_no > 0) {
                                                        formData.page_no--;
                                                        initData();
                                                    }
                                                }}
                                            >Previous</a>
                                            <ul class="pagination listjs-pagination mb-0"></ul>
                                            <a class="page-item pagination-next" href="javascript:void(0)"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    formData.page_no++;
                                                    initData();
                                                }}
                                            >Next</a>
                                        </div>
                                    </div>
                                </div>
                                <AddGstDetails1 item={editItem} onAddDepart={handleAddDepart} />
                                <DelBox />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GstDetails1;
